module.exports = __webpack_public_path__ + "static/media/ithaloAzevedo.5cb8db73.jpg";